import React, { useState, useEffect, useRef } from "react";
import * as XLSX from "xlsx";
import {
  Settings,
  Menu,
  Plus,
  Upload,
  Download,
  Trash2,
  Edit2,
  Search,
  Database,
  Code,
  LayoutDashboard,
  Bell,
} from "lucide-react";
import Navbar from "./Navbar.js";
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  IconButton,
  Button,
  TextField,
  Card,
  CardContent,
  CardHeader,
  CardActions,
  Grid,
  Switch,
  FormControlLabel,
  Paper,
  InputAdornment,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
  Chip,
  Divider,
  Checkbox,
} from "@mui/material";
import useFetch from "./useFetch.js";
import swal from "sweetalert";
import axios from "axios";
import $, { data, type } from "jquery";
import config from "../config.js";
import Cookie from "universal-cookie";
import mixpanel from "mixpanel-browser";
import { decrypt } from "./useCryptoJS";
import Editor from "@monaco-editor/react";
import MonacoModalEditor from "./MonacoModalEditor.js";
const initialSources = [];

const MQTTSources = () => {
  // const [sources, setSources] = useState(initialSources);
  const [isScriptActive, setIsScriptActive] = useState(false);
  const [scriptData, setScriptData] = useState(
    `function add(a, b) {\n  return a + b;\n}`
  );
  const [selectedRows, setSelectedRows] = useState([]);
  const [name, setName] = useState("");
  const [host, setHost] = useState("");
  const [port, setPort] = useState("");
  const [topic, setTopic] = useState("");
  const [keyValue, setKeyValue] = useState("");
  const [enable, setEnable] = useState(false);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  // const [clientId, setClientId] = useState("");

  const [isInEditableMode, setIsInEditableMode] = useState(false);
  const [editableData, setEditableData] = useState(null);

  const [openEditor, setOpenEditor] = useState(false);
  const cookies = new Cookie();
  const [ursource, setUrsource] = useState("0000");
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const formRef = useRef(null);
  const [messageError, setMessageError] = useState({
    name: false,
    host: false,
    port: false,
    topic: false,
    key: false,
  });

  let actionInitiatingUser = "";
  let userToken = "";

  try {
    actionInitiatingUser = parseInt(cookies.get("userID"));
    userToken = cookies.get("userToken");
  } catch (error) {}

  const headers = {
    Authorization: `Bearer ${userToken}`,
    "Content-Type": "application/json",
  };

  useEffect(() => {
    setUrsource(decrypt(cookies.get("ursource")));
  }, []);

  useEffect(() => {
    if (editableData) {
      console.log("Setting form for edit:", editableData);
      setName(editableData.name ?? "");
      setHost(editableData.host ?? "");
      setPort(editableData.port ?? "");
      setTopic(editableData.topic ?? "");
      setKeyValue(editableData.key ?? "");
      setEnable(editableData.enable ?? false);
      setUsername(editableData.username ?? "");
      setPassword(editableData.password ?? "");
      setScriptData(editableData.code ?? "");
      setIsScriptActive(editableData.is_active ?? false);

      // Optional: change button to UPDATE mode
      setIsInEditableMode(true);
    }
  }, [editableData]);
  const {
    isPending,
    data: sources,
    error,
  } = useFetch({
    actionInitiatingUser: { userID: actionInitiatingUser },
    URL: config.BACKEND_URL + "/logger_sources/sources/mqtt",
  });
  const [rows, setRows] = useState();

  useEffect(() => {
    if (sources) {
      setRows(sources);
    }
  }, [sources]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 300);

    return () => clearTimeout(timer);
  }, [searchQuery]);

  const filteredRows =
    rows?.data?.filter((row) => {
      const rowText = Object.values(row)
        .map((v) => String(v).toLowerCase())
        .join(" ");
      return rowText.includes(debouncedSearch.toLowerCase());
    }) || [];

  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10; // 10 rows per page
  const totalRows = filteredRows?.length;
  const start = (currentPage - 1) * pageSize;
  const end = start + pageSize;
  const totalPages = Math.ceil(totalRows / pageSize);

  const paginatedRows = filteredRows.slice(start, end);

  const visibleRows = rows
    ? { ...rows, data: paginatedRows }
    : { columns: [], data: [] };

  const handleDeleteSelected = () => {
    if (selectedRows.length === 0) return;

    swal({
      title: "Are you sure?",
      text: `Delete ${selectedRows.length} selected source(s)?`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (confirmed) => {
      if (!confirmed) return;

      const ids = selectedRows.map((row) => row.id);
      console.log("Deleting IDs:", ids);

      try {
        await axios.post(
          config.BACKEND_URL + "/logger_sources/sources/delete-by-ids",
          {
            sourceIDs: ids,
            actionInitiatingUser,
          },
          { headers }
        );

        swal("Deleted!", "Selected sources have been removed.", "success");
        console.log("Deleted IDs:", rows);

        setRows((prev) => ({
          ...prev,
          data: prev.data.filter((row) => !ids.includes(row.id)),
        }));

        setSelectedRows([]); // Clear selection
      } catch (err) {
        console.error(err);
        swal("Error", "Failed to delete selected sources.", "error");
      }
    });
  };

  const handleDeleteButton = (e, row) => {
    e.preventDefault();
    mixpanel.track("MQTT Delete Button Clicked", {
      userID: cookies.get("userID"),
    });
    if (ursource.charAt(3) !== "1") {
      swal("No Permission", "You cannot perform delete operation", "error");
      return;
    }
    if (row.length === 0) {
      swal(
        "Invalid selection!",
        "You have not selected any rows for deleting!",
        "error"
      );
    } else {
      swal({
        title: "Are you sure?",
        text: "Do you want to delete the selected sources?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          try {
            await axios
              .post(
                config.BACKEND_URL + "/logger_sources/sources/delete-by-ids",
                {
                  sourceIDs: [row.id],
                  actionInitiatingUser,
                },
                { headers }
              )
              .then((res) => {
                swal(
                  "Sources deleted successfully!",
                  "Click on OK to continue...",
                  "success"
                ).then(() => {
                  setRows((prev) => ({
                    ...prev,
                    data: prev.data.filter((r) => r.id !== row.id),
                  }));

                  setSelectedRows([]);
                });
              })
              .catch((err) => {
                console.log(err);
              });
          } catch (err) {
            swal(
              "Error!",
              "Your selected sources have not been deleted due to a server error!",
              "error"
            );
          }
        } else {
          swal(
            "Cancelled!",
            "Your selected rows have not been deleted!",
            "error"
          );
        }
      });
    }
  };

  const resetForm = () => {
    setName("");
    setHost("");
    setPort("");
    setTopic("");
    setKeyValue("");
    setEnable(false);
    setUsername("");
    setPassword("");
    setIsScriptActive(false);
    setScriptData(`function add(a, b) {\n  return a + b;\n}`);
    setEditableData(null);
    setIsInEditableMode(false);
  };

  const handleEditButton = (e, row) => {
    mixpanel.track("MQTT Edit Button Clicked", {
      userID: cookies.get("userID"),
    });
    if (ursource.charAt(2) !== "1") {
      swal("No Permission", "You cannot perform edit operation", "error");
      return;
    }
    console.log("Editing Row:", row);
    setEditableData(row); // store row
    setIsInEditableMode(true); // switch button to Update mode
    setMessageError((prev) =>
      Object.fromEntries(Object.keys(prev).map((key) => [key, false]))
    );

    formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    formRef.current.style.boxShadow = "0 0 10px #3b82f6";
    setTimeout(() => {
      formRef.current.style.boxShadow = "none";
    }, 1000);
  };

  const validate = () => {
    const newErrors = {
      name: name.trim() === "",
      host: host.trim() === "",
      port: port === "" || Number(port) <= 0,
      topic: topic.trim() === "",
      key: keyValue.trim() === "",
    };
    setMessageError(newErrors);

    return Object.values(newErrors).every((v) => v === false);
  };

  const validateScriptSyntax = (code) => {
    try {
      // Just checks syntax, does not run
      new Function(code);

      // Optional: enforce function name
      if (!code.includes("function")) {
        throw new Error("Script must contain a function");
      }

      return { valid: true };
    } catch (err) {
      return {
        valid: false,
        error: err.message,
      };
    }
  };

  const handleMQTTForm = async (e) => {
    e.preventDefault();

    mixpanel.track("MQTT Submit Button Clicked", {
      userID: cookies.get("userID"),
    });

    // Permission Check
    if (ursource.charAt(2) === "0" || ursource.charAt(1) === "0") {
      swal(
        "No Permission",
        "You cannot perform create/edit operation",
        "error"
      );
      return;
    }

    if (!validate()) {
      console.log("Validation failed");
      return;
    }

    if (isScriptActive) {
      if (!scriptData || !scriptData.trim()) {
        swal("Error!", "Script is enabled but no code is provided", "error");
        return;
      }

      const result = validateScriptSyntax(scriptData);

      if (!result.valid) {
        swal("Script Error", result.error, "error");
        return;
      }
    }
    // Build data payload
    const data = {
      host,
      port,
      topic,
      key: keyValue,
    };

    if (username && !password) {
      swal("Error!", "Please enter password if username is provided", "error");
      return;
    }

    if (!username && password) {
      swal("Error!", "Please enter username if password is provided", "error");
      return;
    }

    if (username && password) {
      data.username = username;
      data.password = password;
    }

    // if (clientId) data.clientId = clientId;

    const apiBody = !isInEditableMode
      ? {
          name,
          type: "MQTT",
          data,
          enable,
          actionInitiatingUser,
          script: scriptData?.trim()
            ? {
                code: scriptData,
                is_active: isScriptActive,
              }
            : null,
        }
      : {
          name,
          host,
          port,
          topic,
          key: keyValue,
          enable,
          username,
          password,
          // clientId,
          actionInitiatingUser,
          script: scriptData?.trim()
            ? {
                code: scriptData,
                is_active: isScriptActive,
              }
            : null,
        };

    const actionText = isInEditableMode ? "edit" : "add";

    swal({
      title: "Are you sure?",
      text: `Do you want to ${actionText} this data source?`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (confirmed) => {
      if (!confirmed) {
        swal(`Data source not ${actionText}ed!`, "", "info");
        return;
      }

      try {
        if (!isInEditableMode) {
          // CREATE
          const res = await axios.post(
            `${config.BACKEND_URL}/logger_sources/sources/mqtt`,
            apiBody,
            { headers }
          );
          const newSource = {
            ...res.data.data,
            id: res.data.id,
            name: res.data.name,
            enable: res.data.enable,
            type: res.data.type,
            // alarmIDs: res.data.alarmIDs,
            createdAt: res.data.createdAt,
            updatedAt: res.data.updatedAt,
          };

          swal("Source added successfully!", "", "success");

          // Update table UI without reload
          setRows((prev) => ({
            ...prev,
            data: [...prev.data, newSource], // append new row
          }));

          resetForm();
          setIsInEditableMode(false);
        } else {
          // UPDATE
          const res = await axios.patch(
            `${config.BACKEND_URL}/logger_sources/sources/mqtt/${editableData.id}`,
            apiBody,
            { headers }
          );
          swal("Source updated successfully!", "", "success");
          // Build updated row manually since backend returns only a message
          const updatedSource = {
            id: editableData.id, // keep original id
            name,
            enable,
            type: editableData.type, // keep original type
            createdAt: editableData.createdAt,
            updatedAt: new Date().toISOString(), // or keep old updatedAt
            code: scriptData,
            is_active: isScriptActive,
            // flatten nested data fields
            host,
            port,
            topic,
            key: keyValue,
            username: "",
            password: "",
          };
          // Update UI without reload
          setRows((prev) => ({
            ...prev,
            data: prev.data.map((r) =>
              r.id === editableData.id ? updatedSource : r
            ),
          }));
          console.log("Updated Source:", rows);

          resetForm();
          setIsInEditableMode(false);
        }
      } catch (err) {
        console.error(err);
        swal(
          "Error!",
          err.response?.data?.message || "Failed to save the data source.",
          "error"
        );
      }
    });
  };

  const handleCancelForm = (e) => {
    e.preventDefault();
    mixpanel.track("MQTT Cancel Button Clicked", {
      userID: cookies.get("userID"),
    });
    resetForm();
    setIsInEditableMode(false);
  };

  const handleScriptToggle = (e) => {
    setOpenEditor(true);
  };

  // Excel Upload Functionality
  const handleFileUpload = (event) => {
    if (ursource.charAt(1) !== "1") {
      swal("No Permission", "You cannot perform create operation", "error");
      return;
    }

    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      processExcelData(jsonData);
    };
    reader.readAsBinaryString(file);
  };

  const generateSampleExcel = () => {
    const sampleData = [
      {
        name: "Example Source",
        host: "example.com",
        port: 1883,
        topic: "example/topic",
        key: "data.value",
        enable: 1,
        username: "user",
        password: "pass",
        clientId: "client1",
      },
    ];
    const worksheet = XLSX.utils.json_to_sheet(sampleData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "MQTT Sources");
    XLSX.writeFile(workbook, "MQTT_Sources_Sample.xlsx");
  };

  const validateRow = (row) => {
    const requiredColumns = ["name", "host", "port", "topic", "key"];
    for (const col of requiredColumns) {
      if (!row[col] || row[col].toString().trim() === "") {
        return {
          valid: false,
          message: `Missing or empty required field: ${col}`,
        };
      }
    }

    if (row.password && !row.username) {
      return { valid: false, message: "Password provided without username" };
    }

    if (isNaN(row.port)) {
      return { valid: false, message: "Port must be a number" };
    }

    const enableVal = String(row.enable).toLowerCase().trim();
    if (!["true", "false", "1", "0"].includes(enableVal)) {
      return { valid: false, message: "Enable must be true, false, 1, or 0" };
    }

    return { valid: true };
  };

  const processExcelData = async (jsonData) => {
    const requiredColumns = ["name", "host", "port", "topic", "key", "enable"];
    const validRows = [];
    const invalidRows = [];

    jsonData.forEach((row, index) => {
      const validation = validateRow(row);
      if (validation.valid) {
        validRows.push(row);
      } else {
        invalidRows.push({
          rowIndex: index + 2,
          message: validation.message,
        });
      }
    });

    if (validRows.length === 0) {
      swal(
        "No Valid Rows",
        "The uploaded file contains no valid rows to add.",
        "error"
      );
      return;
    }

    const promises = validRows.map((row) => {
      const source = {
        name: row.name,
        type: "MQTT",
        data: {
          host: row.host,
          port: parseInt(row.port),
          topic: row.topic,
          key: row.key,
          ...(row.username && { username: row.username }),
          ...(row.password && { password: row.password }),
          ...(row.clientId && { clientId: row.clientId }),
        },
        // enable: row.enable === 'true' || row.enable === 1,
        enable: ["true", "1", 1, true].includes(row.enable),
        actionInitiatingUser,
      };
      return axios.post(
        `${config.BACKEND_URL}/logger_sources/sources/mqtt`,
        source,
        { headers }
      );
    });

    try {
      const results = await Promise.all(promises);
      const successes = results.filter((res) => res.status === 200).length;
      const failures = results.length - successes;

      let message = `Successfully added ${successes} sources.`;
      if (failures > 0) message += ` Failed to add ${failures} sources.`;
      if (invalidRows.length > 0)
        message += ` Skipped ${invalidRows.length} invalid rows.`;
      swal("Upload Complete", message, "info").then(() =>
        window.location.reload()
      );
    } catch (error) {
      console.error("Error uploading sources:", error);
      swal("Error", "An error occurred while uploading sources.", "error");
    }
  };
  const hiddenFields = ["code", "is_active"];
  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#0f1729" }}>
      {/* Top Bar */}
      <Navbar />
      {/* Main Content */}
      <Box sx={{ p: 4, maxWidth: "1300px", mx: "auto", mt: 4 }}>
        {/* Header */}
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 4 }}>
          <Box>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                color: "white",
              }}
            >
              MQTT Data Sources
            </Typography>

            <Typography
              sx={{
                fontSize: "1.1rem",
                color: "rgba(255,255,255,0.7)",
                mt: 0.5,
              }}
            >
              Manage your connected devices and data streams.
            </Typography>
          </Box>

          <Button
            variant="outlined"
            startIcon={<Download />}
            onClick={generateSampleExcel}
            sx={{
              color: "white",
              borderColor: "#334155",
              "&:hover": { borderColor: "#60a5fa" },
            }}
          >
            Sample Format
          </Button>
        </Box>

        <Grid container spacing={3}>
          {/* FORM CARD */}
          <Grid item xs={12} md={8}>
            <Card
              ref={formRef}
              elevation={0}
              sx={{
                background: "rgba(15, 23, 42, 0.6)", // glassy dark
                backdropFilter: "blur(12px)", // frosted glass
                WebkitBackdropFilter: "blur(12px)", // Safari support
                color: "white",
                borderRadius: "16px",
                border: "1px solid rgba(148, 163, 184, 0.15)",

                boxShadow:
                  "0 0 0 1px rgba(255,255,255,0.05), 0 4px 12px rgba(49, 56, 163, 0.4)",

                p: 3,
              }}
            >
              {/* HEADER */}
              <Box sx={{ mb: 1 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Plus size={20} color="#60a5fa" />
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    Add New Source
                  </Typography>
                </Box>

                <Typography
                  variant="body2"
                  sx={{ color: "rgba(255,255,255,0.6)", mt: 0.5 }}
                >
                  Configure a new MQTT connection.
                </Typography>
              </Box>

              <Divider sx={{ borderColor: "#1e293b", mb: 3 }} />

              <CardContent sx={{ p: 0 }}>
                <Grid container spacing={2}>
                  {/* Upload Buttons */}
                  <Grid item xs={12} sx={{ display: "flex", gap: 2 }}>
                    <Grid item xs={6}>
                      <label htmlFor="excel-upload" style={{ width: "100%" }}>
                        <input
                          id="excel-upload"
                          type="file"
                          accept=".xlsx, .xls"
                          onChange={handleFileUpload}
                          style={{ display: "none" }}
                        />

                        <Button
                          component="span"
                          fullWidth
                          variant="outlined"
                          startIcon={<Upload size={16} />}
                          sx={{
                            color: "white",
                            borderColor: "#334155",
                            borderStyle: "dashed",
                            bgcolor: "#0f1729",
                            textTransform: "none",
                            "&:hover": {
                              borderColor: "#60a5fa",
                              bgcolor: "#1e293b",
                            },
                          }}
                        >
                          Upload Excel
                        </Button>
                      </label>
                    </Grid>

                    {/* Add Script */}
                    <Grid item xs={6}>
                      <Button
                        fullWidth
                        variant="outlined"
                        startIcon={<Code size={16} />}
                        sx={{
                          color: "white",
                          borderColor: "#334155",
                          borderStyle: "dashed",
                          bgcolor: "#0f1729",
                          textTransform: "none",
                          "&:hover": {
                            borderColor: "#60a5fa",
                            bgcolor: "#1e293b",
                          },
                        }}
                        onClick={handleScriptToggle}
                      >
                        Add Script
                      </Button>
                    </Grid>
                  </Grid>

                  {/* INPUTS */}
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Host"
                      value={host}
                      onChange={(e) => {
                        setHost(e.target.value);
                        setMessageError((prev) => ({
                          ...prev,
                          host: e.target.value.trim() === "",
                        }));
                      }}
                      error={messageError.host}
                      helperText={messageError.host ? "Host is required" : ""}
                      fullWidth
                      placeholder="e.g. mqtt.example.com"
                      InputLabelProps={{ style: { color: "#94a3b8" } }}
                      sx={{
                        input: { color: "white" },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": { borderColor: "#334155" },
                          "&:hover fieldset": { borderColor: "#60a5fa" },
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={8} md={6}>
                    <TextField
                      label="Topic"
                      value={topic}
                      onChange={(e) => {
                        setTopic(e.target.value);
                        setMessageError((prev) => ({
                          ...prev,
                          topic: e.target.value.trim() === "",
                        }));
                      }}
                      error={messageError.topic}
                      helperText={messageError.topic ? "Topic is required" : ""}
                      fullWidth
                      placeholder="sensors/#"
                      InputLabelProps={{ style: { color: "#94a3b8" } }}
                      sx={{
                        input: { color: "white" },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": { borderColor: "#334155" },
                          "&:hover fieldset": { borderColor: "#60a5fa" },
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={4} md={6}>
                    <TextField
                      label="Port"
                      type="number"
                      value={port}
                      onChange={(e) => {
                        setPort(e.target.value);
                        setMessageError((prev) => ({
                          ...prev,
                          port:
                            e.target.value === "" ||
                            Number(e.target.value) <= 0,
                        }));
                      }}
                      error={messageError.port}
                      helperText={messageError.port ? "port is required" : ""}
                      fullWidth
                      placeholder="1883"
                      InputLabelProps={{ style: { color: "#94a3b8" } }}
                      sx={{
                        input: { color: "white" },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": { borderColor: "#334155" },
                          "&:hover fieldset": { borderColor: "#60a5fa" },
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Source Name"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                        setMessageError((prev) => ({
                          ...prev,
                          name: e.target.value.trim() === "",
                        }));
                      }}
                      error={messageError.name}
                      helperText={
                        messageError.name ? "Source name is required" : ""
                      }
                      fullWidth
                      placeholder="Friendly name"
                      InputLabelProps={{ style: { color: "#94a3b8" } }}
                      sx={{
                        input: { color: "white" },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": { borderColor: "#334155" },
                          "&:hover fieldset": { borderColor: "#60a5fa" },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <TextField
                      label="Key"
                      value={keyValue}
                      onChange={(e) => {
                        setKeyValue(e.target.value);
                        setMessageError((prev) => ({
                          ...prev,
                          key: e.target.value.trim() === "",
                        }));
                      }}
                      error={messageError.key}
                      helperText={messageError.key ? "key is required" : ""}
                      fullWidth
                      placeholder="Key name"
                      InputLabelProps={{ style: { color: "#94a3b8" } }}
                      sx={{
                        input: { color: "white" },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": { borderColor: "#334155" },
                          "&:hover fieldset": { borderColor: "#60a5fa" },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Username"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      fullWidth
                      placeholder=" Username"
                      autoComplete="new-username"
                      InputLabelProps={{ style: { color: "#94a3b8" } }}
                      sx={{
                        input: { color: "white" },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": { borderColor: "#334155" },
                          "&:hover fieldset": { borderColor: "#60a5fa" },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      fullWidth
                      type="password"
                      autoComplete="new-password"
                      InputLabelProps={{ style: { color: "#94a3b8" } }}
                      sx={{
                        input: { color: "white" },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": { borderColor: "#334155" },
                          "&:hover fieldset": { borderColor: "#60a5fa" },
                        },
                      }}
                    />
                  </Grid>

                  {/* Switch + Button */}
                  <Grid
                    item
                    xs={12}
                    sx={{
                      mt: 2,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Switch
                          checked={enable}
                          onChange={(e) => setEnable(e.target.checked)}
                          sx={{
                            "& .MuiSwitch-thumb": { bgcolor: "white" },
                            "& .MuiSwitch-track": { bgcolor: "#334155" },
                          }}
                        />
                      }
                      label={
                        <Typography sx={{ color: "white", fontWeight: 600 }}>
                          Enable Logging
                        </Typography>
                      }
                    />

                    <FormControlLabel
                      control={
                        <Switch
                          checked={isScriptActive}
                          onChange={(e) => setIsScriptActive(e.target.checked)}
                          sx={{
                            "& .MuiSwitch-thumb": { bgcolor: "white" },
                            "& .MuiSwitch-track": { bgcolor: "#334155" },
                          }}
                        />
                      }
                      label={
                        <Typography sx={{ color: "white", fontWeight: 600 }}>
                          Enable Script
                        </Typography>
                      }
                    />

                    <Box sx={{ display: "flex", gap: 2 }}>
                      <Button
                        variant="contained"
                        onClick={handleMQTTForm}
                        sx={{
                          bgcolor: "#3b82f6",
                          color: "white",
                          px: 2,
                          py: 1.2,
                          borderRadius: "8px",
                          textTransform: "none",
                          "&:hover": { bgcolor: "#2563eb" },
                        }}
                      >
                        {isInEditableMode
                          ? "Update Data Source"
                          : "Create Data Source"}
                      </Button>

                      {isInEditableMode && (
                        <Button
                          variant="contained"
                          onClick={handleCancelForm}
                          sx={{
                            bgcolor: "#f63b3b !important",
                            color: "white",
                            px: 2,
                            py: 1.2,
                            borderRadius: "8px",
                            textTransform: "none",
                            "&:hover": {
                              bgcolor: "#dc2626 !important",
                            }, // darker red on hover
                          }}
                        >
                          Cancel
                        </Button>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          {/* HELPER CARD */}
          <Grid item xs={12} md={4}>
            <Card
              sx={{
                bgcolor: "#1e293b",
                color: "white",
                borderRadius: "16px",
                border: "1px solid #334155",
                p: 2,
              }}
            >
              <CardContent>
                {/* Block 1 */}
                <Box display="flex" gap={2} mb={2}>
                  <Box
                    sx={{
                      p: 1.2,
                      color: "#3b82f6",
                      bgcolor: "rgba(59,130,246,0.15)",
                      borderRadius: "50%",
                      display: "flex",
                      width: 45,
                      height: 45,
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <LayoutDashboard size={20} />
                  </Box>

                  <Box>
                    <Typography fontWeight={600}>
                      Need help connecting?
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "rgba(255,255,255,0.6)" }}
                    >
                      Ensure your broker accepts connections. Use port 8883 for
                      TLS/SSL.
                    </Typography>
                  </Box>
                </Box>

                <Divider sx={{ mb: 2, borderColor: "#334155" }} />

                {/* Block 2 */}
                <Box display="flex" gap={2}>
                  <Box
                    sx={{
                      p: 1.2,
                      color: "#3b82f6",
                      bgcolor: "rgba(59,130,246,0.15)",
                      borderRadius: "50%",
                      display: "flex",
                      width: 45,
                      height: 45,
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Database size={20} />
                  </Box>

                  <Box>
                    <Typography fontWeight={600}>
                      Sample Configuration
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "rgba(255,255,255,0.6)" }}
                    >
                      Host: test.mosquitto.org <br />
                      Port: 1883 <br />
                      Topic: devices/+/status
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <MonacoModalEditor
          open={openEditor} // <-- your modal state
          initialValue={scriptData} // <-- initial code
          language="javascript"
          title="Script Editor"
          onSave={(newCode) => {
            setScriptData(newCode); // <-- update your script data
            setOpenEditor(false); // <-- close modal
          }}
          onClose={() => setOpenEditor(false)}
        />

        {/* TABLE */}
        <Card
          sx={{
            mt: 4,
            bgcolor: "#0f1729",
            color: "white",
            borderRadius: "16px",
            border: "1px solid #1e293b",
            p: 2,
          }}
        >
          {/* SEARCH BAR */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Connected Sources
            </Typography>
            <TextField
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search sources..."
              size="small"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search size={18} color="#64748b" />
                  </InputAdornment>
                ),
                sx: {
                  bgcolor: "rgba(255,255,255,0.05)",
                  borderRadius: "8px",
                  color: "white",
                },
              }}
              sx={{
                width: 280,
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#334155",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#60a5fa",
                },
              }}
            />
          </Box>

          {/* If no sources → show empty state */}
          {rows?.data?.length === 0 ? (
            <Box
              sx={{
                py: 8,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                color: "rgba(148,163,184,0.8)",
                textAlign: "center",
              }}
            >
              <Database size={60} color="#64748b" />

              <Typography
                variant="h6"
                sx={{ mt: 2, fontWeight: 500, color: "#cbd5e1" }}
              >
                No MQTT sources configured yet.
              </Typography>

              <Typography
                variant="body2"
                sx={{ mt: 1, color: "rgba(148,163,184,0.8)" }}
              >
                Add your first source above to get started.
              </Typography>
            </Box>
          ) : (
            <Box>
              {/* SCROLLABLE TABLE WRAPPER */}
              <Box
                sx={{
                  overflowX: "auto",
                }}
              >
                <Button
                  variant="contained"
                  disabled={selectedRows.length === 0}
                  onClick={handleDeleteSelected}
                >
                  Delete Selected ({selectedRows.length})
                </Button>

                <Table
                  sx={{
                    backgroundColor: "#0f1729",
                    borderRadius: "12px",
                    minWidth: 900, // REQUIRED for horizontal scroll
                  }}
                >
                  {/* TABLE HEADER */}
                  <TableHead>
                    <TableRow
                      sx={{
                        bgcolor: "#1e293b",
                        "& th": { color: "#94a3b8", fontWeight: 600 },
                      }}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          sx={{ color: "#bfbfbfff" }}
                          checked={
                            rows?.data?.length > 0 &&
                            selectedRows.length === rows?.data?.length
                          }
                          indeterminate={
                            selectedRows.length > 0 &&
                            selectedRows.length < rows?.data?.length
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedRows(rows.data); // Select ALL rows
                            } else {
                              setSelectedRows([]); // Clear selection
                            }
                          }}
                        />
                      </TableCell>

                      {/* <TableCell></TableCell> */}
                      {rows?.columns
                        ?.filter((col) => !hiddenFields.includes(col.field))
                        .map((col) => (
                          <TableCell key={col.field}>{col.title}</TableCell>
                        ))}
                      <TableCell align="right">Actions</TableCell>
                    </TableRow>
                  </TableHead>

                  {/* TABLE BODY */}
                  <TableBody>
                    {visibleRows?.data?.map((row) => (
                      <TableRow
                        key={row.id}
                        sx={{
                          "& td": {
                            borderBottom: "1px solid #1e293b",
                            color: "#e2e8f0",
                          },
                          "&:hover": {
                            backgroundColor: "rgba(255,255,255,0.03)",
                          },
                        }}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            sx={{ color: "#d6d6d6ff" }}
                            checked={selectedRows.some((r) => r.id === row.id)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedRows((prev) => [...prev, row]);
                              } else {
                                setSelectedRows((prev) =>
                                  prev.filter((r) => r.id !== row.id)
                                );
                              }
                            }}
                          />
                        </TableCell>

                        {/* DYNAMIC CELLS */}
                        {visibleRows?.columns
                          ?.filter((col) => !hiddenFields.includes(col.field))
                          .map((col) => (
                            <TableCell key={col.field}>
                              {col.field === "topic" ? (
                                <Typography
                                  sx={{
                                    color: "#60a5fa",
                                    cursor: "pointer",
                                    fontWeight: 500,
                                  }}
                                >
                                  {row[col.field]}
                                </Typography>
                              ) : col.field === "port" ? (
                                <Typography sx={{ fontWeight: 700 }}>
                                  {row[col.field]}
                                </Typography>
                              ) : col.field === "name" ? (
                                <Typography sx={{ fontWeight: 600 }}>
                                  {row[col.field]}
                                </Typography>
                              ) : col.field === "enable" ? (
                                <Chip
                                  label={row.enable ? "Active" : "Inactive"}
                                  color={row.enable ? "success" : "error"}
                                  size="small"
                                  sx={{ fontWeight: 700 }}
                                />
                              ) : (
                                row[col.field]
                              )}
                            </TableCell>
                          ))}

                        {/* ACTIONS */}
                        <TableCell align="right">
                          <Box
                            sx={{
                              display: "flex",
                              gap: 1,
                              justifyContent: "flex-end",
                              alignItems: "center",
                            }}
                          >
                            <IconButton
                              onClick={(e) => handleEditButton(e, row)}
                              sx={{
                                color: "#64748b",
                                "&:hover": { color: "#3b82f6" },
                              }}
                            >
                              <Edit2 size={18} />
                            </IconButton>

                            <IconButton
                              onClick={(e) => handleDeleteButton(e, row)}
                              sx={{
                                color: "#64748b",
                                "&:hover": { color: "#ef4444" },
                              }}
                            >
                              <Trash2 size={18} />
                            </IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>

              {/* FOOTER IS NOW OUTSIDE SCROLL */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mt: 2,
                  color: "#94a3b8",
                  fontSize: "0.85rem",
                }}
              >
                <span>
                  Showing {currentPage} of {totalPages} sources
                </span>

                <Box sx={{ display: "flex", gap: 1 }}>
                  <Button
                    variant="outlined"
                    onClick={() => setCurrentPage((p) => p - 1)}
                    disabled={currentPage === 1}
                    sx={{
                      borderColor: "#334155 !important",
                      color: "rgba(255,255,255,0.6) !important",
                      textTransform: "none",
                      "&.Mui-disabled": {
                        borderColor: "#334155",
                        color: "rgba(255,255,255,0.4)",
                        opacity: 1,
                      },
                    }}
                  >
                    Prev
                  </Button>

                  <Button
                    variant="outlined"
                    onClick={() => setCurrentPage((p) => p + 1)}
                    disabled={currentPage === totalPages}
                    sx={{
                      borderColor: "#334155 !important",
                      color: "rgba(255,255,255,0.6) !important",
                      textTransform: "none",
                      "&.Mui-disabled": {
                        borderColor: "#334155",
                        color: "rgba(255,255,255,0.4)",
                        opacity: 1,
                      },
                    }}
                  >
                    Next
                  </Button>
                </Box>
              </Box>
            </Box>
          )}
        </Card>
      </Box>
    </Box>
  );
};
export default MQTTSources;
